import { addSeconds } from "date-fns";

import { RootState, TimelineSegmentOpType } from "shared/types";
import { getBreakoutForTimelineSegment } from "utils/timeline";

export const selectActiveTimelineSegmentId = () => (state: RootState) =>
  state.classroom.client.active_timeline_segment_id;

export const selectActiveTimelineSectionEndTime = () => (state: RootState) => {
  const activeTimelineSegmentId = state.classroom.client.active_timeline_segment_id;
  const classInfo = state.classroom.client.info;
  if (classInfo.date === null || classInfo.end_time === null) return undefined;
  if (!activeTimelineSegmentId) return new Date(classInfo.end_time);

  const classStartTime = new Date(classInfo.date);
  let durationUntilNextSectionInSeconds = 0;
  for (const section of state.classroom.client.timeline.sections) {
    durationUntilNextSectionInSeconds += section.duration_in_seconds;
    for (const segment of section.segments) {
      if (segment.id === activeTimelineSegmentId) {
        return addSeconds(classStartTime, durationUntilNextSectionInSeconds);
      }
    }
  }
};

export const selectActiveTimelineSegment = () => (state: RootState) => {
  const activeTimelineSegmentId = state.classroom.client.active_timeline_segment_id;
  if (!activeTimelineSegmentId) return undefined;
  for (const section of state.classroom.client.timeline.sections) {
    for (const segment of section.segments) {
      if (segment.id === activeTimelineSegmentId) {
        return segment;
      }
    }
  }
};

export const selectTimeline = () => (state: RootState) => state.classroom.client.timeline;

export const selectTimelineIsEmpty = () => (state: RootState) =>
  // Students do not see the timeline at all, so instead we set the is_empty flag
  state.classroom.client.timeline.is_empty === undefined
    ? state.classroom.client.timeline.sections.length === 0
    : state.classroom.client.timeline.is_empty;

export const selectActiveOrPrecedingSegmentBreakout = () => (state: RootState) => {
  const activeTimelineSegment = selectActiveTimelineSegment()(state);
  if (!activeTimelineSegment) return null;

  const activeSegmentBreakout = getBreakoutForTimelineSegment(
    activeTimelineSegment,
    Object.values(state.classroom.client.breakouts),
  );
  if (activeSegmentBreakout) return activeSegmentBreakout;

  const activeSection = state.classroom.client.timeline.sections.find((section) =>
    section.segments.some((segment) => segment.id === activeTimelineSegment.id),
  );
  if (!activeSection) return null;

  let precedingBreakout = null;
  for (let i = 0; i < activeSection.segments.length; i += 1) {
    const segment = activeSection.segments[i];
    if (segment.id === activeTimelineSegment.id) {
      break;
    }
    if (segment.op === TimelineSegmentOpType.Breakout) {
      precedingBreakout = getBreakoutForTimelineSegment(
        segment,
        Object.values(state.classroom.client.breakouts),
      );
    }
  }
  return precedingBreakout;
};
